import { render, staticRenderFns } from "./ImportItemsDialog.vue?vue&type=template&id=256497b5&scoped=true"
import script from "./ImportItemsDialog.vue?vue&type=script&lang=ts"
export * from "./ImportItemsDialog.vue?vue&type=script&lang=ts"
import style0 from "./ImportItemsDialog.vue?vue&type=style&index=0&id=256497b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256497b5",
  null
  
)

export default component.exports